export default "__VITE_ASSET__3c8b9f71__"